import { Objetivo } from './objetivo.model';
import { Riesgo } from './riesgo.model';
import { Evaluacion } from './evaluacion.model';
import { AnalisisInherente } from './analisis-inherente.model';
import { AnalisisResidual } from './analisis-residual.model';
import { Ponderacion } from './ponderacion.model';

export class ObjetivoRiesgo
{
    id: number;
    objetivo: Objetivo;
    riesgo: Riesgo;
    nombre: string;
    analisisInherente: AnalisisInherente[];
    analisisResidual: AnalisisResidual[];
    topAnalisisInherente: AnalisisInherente;
    topAnalisisResidual: AnalisisResidual;
    evaluacion: Evaluacion;
    cantidadControles: number;
    impactoPonderado:number;
    factor: Ponderacion;
    /**
     * Constructor
     *
     * @param objetivoRiesgo
     */
    constructor(objetivoRiesgo)
    {
        {
            this.id = objetivoRiesgo.id || null;
            this.objetivo = objetivoRiesgo.objetivo || null;
            this.riesgo = objetivoRiesgo.riesgo || null;
            this.analisisInherente = objetivoRiesgo.analisisInherente || [];
            this.analisisResidual = objetivoRiesgo.analisisResidual || [];
            this.topAnalisisInherente = objetivoRiesgo.topAnalisisInherente || new AnalisisInherente({}) ;
            this.topAnalisisResidual  = objetivoRiesgo.topAnalisisResidual || new AnalisisResidual({}) ;
            this.nombre = objetivoRiesgo.nombre;
            this.cantidadControles = objetivoRiesgo.cantidadControles || 0;
            this.impactoPonderado = objetivoRiesgo.impactoPonderado || 0;
            this.factor = objetivoRiesgo.factor || null;
        }
    }
}
